/* Customer-theme only. The RFQ submit/account/email endpoints are unchanged. */
(function () {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const controls = new Set(), desired = new Map(), savedItems = new Map();
  let cart = null, loading = null, busy = false, timer, undo, toastTimer;
  const quantity = raw => /^\d+$/.test(String(raw).trim()) && Number(raw) <= 100000 ? Number(raw) : null;
  const matches = id => (cart?.items || []).filter(i => String(i.variant_id) === String(id));
  const actual = id => matches(id).reduce((n,i) => n + i.quantity, 0);
  const displayed = id => desired.has(String(id)) ? desired.get(String(id)) : actual(id);
  const pending = () => busy || desired.size > 0;
  function notify(message, action) {
    const el = document.getElementById('CSFCartStatus');
    if (!el) return;
    clearTimeout(toastTimer); undo = action || null;
    el.querySelector('[data-csf-status]').textContent = message;
    el.querySelector('[data-csf-undo]').hidden = !undo;
    el.hidden = false;
    if (action) toastTimer = setTimeout(() => { el.hidden = true; undo = null; }, 8000);
  }
  async function json(url, options) {
    const response = await fetch(url, {credentials:'same-origin',cache:'no-store',...options});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw Error(data.description || data.message || 'Your changes could not be saved. Please try again.');
    return data;
  }
  async function load() {
    if (!loading) loading = json(root+'cart.js').then(data => { cart = data; sync(); return data; }).finally(() => { loading = null; });
    return loading;
  }
  function sync() {
    controls.forEach(control => control.updateUI());
    let count = cart?.item_count || 0;
    for (const [id,q] of desired) count += q - actual(id);
    document.querySelectorAll('[data-csf-count]').forEach(el => el.textContent = count);
    const bar = document.getElementById('CSFOrderBar');
    if (bar) bar.hidden = count === 0 || /\/(cart|pages\/request-quote)\/?$/.test(location.pathname);
    document.body.classList.toggle('csf-has-order',!!bar && !bar.hidden);
    document.querySelectorAll('[data-csf-open]').forEach(el => el.setAttribute('aria-busy',String(pending())));
    document.querySelectorAll('[data-csf-best-add]').forEach(el => { el.disabled = !cart || pending(); el.setAttribute('aria-busy',String(desired.has(el.dataset.csfBestAdd))); });
    const link = document.getElementById('CartDrawer-Checkout');
    if (link) { link.setAttribute('aria-disabled',String(pending())); link.classList.toggle('csf-saving',pending()); }
    // Native cart controls must not race the queued card writes.
    document.querySelectorAll('cart-drawer input[name="updates[]"],cart-drawer .quantity__button,cart-drawer cart-remove-button button').forEach(el=>el.disabled=pending());
  }
  function sections() { return document.querySelector('cart-drawer')?.getSectionsToRender().map(s=>s.id) || ['cart-icon-bubble']; }
  function refresh(data) {
    const suggestionScroll = document.querySelector('[data-csf-best-track]')?.scrollLeft || 0;
    const restoreSuggestionFocus = !!document.activeElement?.closest?.('[data-csf-best-add]');
    const drawer = document.querySelector('cart-drawer');
    const drawerOpen = drawer?.classList.contains('active');
    const pagePosition = {left:window.scrollX,top:window.scrollY};
    const oldScroller = drawer?.querySelector('cart-drawer-items');
    const oldScrollTop = oldScroller?.scrollTop || 0;
    const oldSuggestions = drawer?.querySelector('.csf-cart-best');
    const oldSuggestionTop = oldSuggestions?.getBoundingClientRect().top;
    const anchorSuggestions = drawerOpen && oldSuggestions && oldScroller &&
      oldSuggestions.getBoundingClientRect().bottom > oldScroller.getBoundingClientRect().top &&
      oldSuggestionTop < oldScroller.getBoundingClientRect().bottom;
    let drawerRendered = false;
    const parts = drawer?.getSectionsToRender() || [{id:'cart-icon-bubble'}];
    for (const part of parts) {
      const html = data.sections?.[part.id]; if (!html) continue;
      const selector = part.selector || '.shopify-section';
      const source = new DOMParser().parseFromString(html,'text/html').querySelector(selector);
      const target = part.selector ? document.querySelector(part.selector) : document.getElementById(part.id);
      if (source && target) {
        target.innerHTML = source.innerHTML;
        if (part.id === 'cart-drawer') drawerRendered = true;
      }
    }
    drawer?.classList.toggle('is-empty',cart.item_count === 0);
    // Section replacement creates a new overlay; keep its close action working.
    const overlay = document.getElementById('CartDrawer-Overlay');
    if (overlay) overlay.onclick = () => drawer.close();
    const suggestionTrack = document.querySelector('[data-csf-best-track]');
    if (suggestionTrack) suggestionTrack.scrollLeft = suggestionScroll;
    if (restoreSuggestionFocus) (document.getElementById('CSFCartBestHeading') || document.getElementById('CartDrawer-Checkout'))?.focus({preventScroll:true});
    const newScroller = drawer?.querySelector('cart-drawer-items');
    if (drawerRendered && newScroller) {
      newScroller.scrollTop = oldScrollTop;
      const newSuggestions = drawer.querySelector('.csf-cart-best');
      if (anchorSuggestions && newSuggestions) newScroller.scrollTop += newSuggestions.getBoundingClientRect().top - oldSuggestionTop;
    }
    if (drawerOpen && (window.scrollX !== pagePosition.left || window.scrollY !== pagePosition.top)) window.scrollTo({...pagePosition,behavior:'instant'});
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'csf-new-cart',cartData:cart,drawerRendered});
    sync();
  }
  async function flush() {
    if (busy || !desired.size) return;
    busy = true; sync();
    try {
      await load();
      while (desired.size) {
        const [id,q] = desired.entries().next().value;
        const items = matches(id);
        if (items.length > 1) throw Error('This product has separate options in your order. Please edit it in View order.');
        if (q === actual(id)) { if (desired.get(id) === q) desired.delete(id); continue; }
        const current = items[0];
        if (!current && q > 0 && cart.items.length >= 500) throw Error('Your order already contains 500 products. Please submit it before starting another. Your saved cart is unchanged.');
        if (current) savedItems.set(id,current);
        const snapshot = savedItems.get(id);
        const body = current ? {id:current.key,quantity:q} : {id:Number(id),quantity:q,...(snapshot?.properties?{properties:snapshot.properties}:{}),...(snapshot?.selling_plan_allocation?{selling_plan:snapshot.selling_plan_allocation.selling_plan.id}:{})};
        body.sections = sections(); body.sections_url = location.pathname;
        const data = await json(root+(current?'cart/change.js':'cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
        cart = current ? data : await json(root+'cart.js');
        if (desired.get(id) === q) desired.delete(id);
        refresh(data);
        if (actual(id) !== q) { desired.delete(id); notify('Shopify adjusted this quantity. Please review your order.'); }
      }
    } catch (error) {
      desired.clear(); undo = null;
      try { await load(); } catch (_) { cart = null; }
      notify(error.message || 'Unable to save. Refresh to verify your order before continuing.');
    } finally { busy = false; sync(); }
  }
  function setQuantity(id, q, label) {
    id = String(id);
    if (quantity(q) === null) return false;
    if (!cart) { notify('Please wait for your order to load, then try again.'); load().catch(e=>notify(e.message)); return false; }
    if (matches(id).length > 1) { notify('This product has separate options in your order. Please edit it in View order.'); return false; }
    const previous = displayed(id);
    if (previous === q) return true;
    if (matches(id)[0]) savedItems.set(id,matches(id)[0]);
    desired.set(id,q); sync();
    if (q === 0 && previous > 0) notify('Removed from your order.',()=>setQuantity(id,previous,label));
    clearTimeout(timer); timer = setTimeout(flush,180);
    return true;
  }
  if (!customElements.get('card-qty-buttons')) customElements.define('card-qty-buttons',class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { controls.add(this); this.updateUI(); return; } this.ready = true;
      this.variantId = this.dataset.variantId; this.title = this.dataset.productTitle || 'product';
      this.input = this.querySelector('.csf-quantity-input');
      if (!this.input) return;
      this.addEventListener('click',event=>{
        const button = event.target.closest('button'); if (!button) return;
        const q = displayed(this.variantId);
        setQuantity(this.variantId,button.name === 'minus' ? Math.max(0,q-1) : q+1,this.title);
      });
      this.input.addEventListener('change',()=>{
        const q=quantity(this.input.value);
        if(q===null){this.input.value=displayed(this.variantId);notify('Enter a whole number from 0 to 100,000.');return;}
        setQuantity(this.variantId,q,this.title);this.updateUI();
      });
      this.input.addEventListener('keydown',event=>{if(event.key==='Enter'){event.preventDefault();this.input.blur();}});
      this.input.addEventListener('focus',()=>this.input.select());
      controls.add(this); this.updateUI();
    }
    disconnectedCallback(){controls.delete(this);}
    updateUI() {
      if(!this.input)return;
      const q=cart?displayed(this.variantId):(Number(this.dataset.cartQty)||0);
      if(document.activeElement!==this.input)this.input.value=q;
      this.querySelector('[name="add"]').hidden=q>0;
      for(const el of [this.input,this.querySelector('[name="minus"]'),this.querySelector('[name="plus"]')])el.hidden=q===0;
      this.querySelector('.csf-minus-icon').hidden=q===1;
      this.querySelector('.csf-trash-icon').hidden=q!==1;
      this.querySelector('[name="minus"]').setAttribute('aria-label',(q===1?'Remove ':'Decrease quantity for ')+this.title);
      this.querySelector('[name="plus"]').disabled=q>=100000||!cart;
      this.querySelector('[name="add"]').disabled=!cart;
      this.input.disabled=!cart;
      this.closest('.card-wrapper')?.classList.toggle('csf-in-order',q>0);
      this.setAttribute('aria-busy',String(desired.has(String(this.variantId))));
    }
  });
  document.addEventListener('click',event=>{
    const suggestion = event.target.closest('[data-csf-best-add]');
    if(suggestion){
      event.preventDefault();
      if(!suggestion.disabled && !pending()) setQuantity(suggestion.dataset.csfBestAdd,displayed(suggestion.dataset.csfBestAdd)+1,suggestion.dataset.productTitle);
      return;
    }
    const arrow = event.target.closest('[data-csf-best-scroll]');
    if(arrow){
      const track = document.getElementById('CSFCartBestTrack');
      track?.scrollBy({left:Number(arrow.dataset.csfBestScroll)*track.clientWidth*0.85,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      return;
    }
    if(event.target.closest('[data-csf-undo]')){const action=undo;undo=null;document.getElementById('CSFCartStatus').hidden=true;action?.();}
    if(event.target.closest('[data-csf-dismiss]'))document.getElementById('CSFCartStatus').hidden=true;
    if(event.target.closest('[data-csf-open]')){document.querySelector('cart-drawer')?.open(event.target.closest('button'));}
    if(event.target.closest('#CartDrawer-Checkout') && (pending()||!cart)){event.preventDefault();event.stopImmediatePropagation();notify('Please wait while your quantities finish saving.');}
  },true);
  window.addEventListener('beforeunload',event=>{if(pending()){event.preventDefault();event.returnValue='';}});
  window.addEventListener('pageshow',()=>{if(!pending())load().catch(e=>notify(e.message));});
  window.addEventListener('focus',()=>{if(!pending())load().catch(()=>{});});
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,event=>{if(event.source==='csf-new-cart'||pending())return;if(event.cartData?.items){cart=event.cartData;sync();}else load().catch(e=>notify(e.message));});
  load().catch(e=>notify(e.message));
  // Pure validation exported only for fixture tests, not an extra network surface.
  if(typeof module!=='undefined')module.exports={quantity,setQuantity,flush,load,displayed,pending};
})();
